import moment from 'moment'
import { isDate } from '@evologi/shared/util-toolkit'
import { StockSearchParams, StockSortField } from '../models/stock-search.model'
import {
  QueryStringFilter,
  QueryStringSort,
} from '../../../models/query-string.model'
import {
  applyComparisonOperator,
  applyDateRangeFilter,
  parseFilters,
} from '../../../libs/filter.lib'

// Search

export function parseStockFilters(
  params: StockSearchParams,
  filters: StockSearchParams,
): StockSearchParams {
  return parseFilters(params, filters, stockFilterParams)
}

export function stockFilterParams(
  params: StockSearchParams,
  filter: QueryStringFilter<keyof StockSearchParams>,
): StockSearchParams {
  const searchParams: StockSearchParams = {}
  const value = Array.isArray(filter.value)
    ? filter.value.length
      ? filter.value[0]
      : undefined
    : filter.value

  // Check date object
  if (
    ['string', 'object'].includes(typeof filter.value) &&
    isDate(filter.value)
  ) {
    filter.value = moment(filter.value).utc().toISOString()
  }

  switch (filter.field) {
    case '_id':
      if (filter.operator === '=') {
        searchParams._id = filter.value
      }
      break
    case 'warehouse._id':
      if (filter.value !== null) {
        searchParams['warehouse._id'] = filter.value
      }
      break
    case 'type':
      if (filter.value !== null) {
        searchParams.type = filter.value
      }
      break
    case 'code':
      if (filter.operator === '=') {
        searchParams.code = filter.value
      }
      break
    case 'onHandQty':
      if (filter.operator === '=') {
        searchParams['onHandQty'] = filter.value
      } else if (filter.operator === '<') {
        searchParams['onHandQty:lt'] = filter.value
      } else if (filter.operator === '<=') {
        searchParams['onHandQty:le'] = filter.value
      } else if (filter.operator === '>') {
        searchParams['onHandQty:gt'] = filter.value
      } else if (filter.operator === '>=') {
        searchParams['onHandQty:ge'] = filter.value
      }
      break
    case 'scrappedQty':
      if (filter.operator === '=') {
        searchParams['scrappedQty'] = filter.value
      } else if (filter.operator === '<') {
        searchParams['scrappedQty:lt'] = filter.value
      } else if (filter.operator === '<=') {
        searchParams['scrappedQty:le'] = filter.value
      } else if (filter.operator === '>') {
        searchParams['scrappedQty:gt'] = filter.value
      } else if (filter.operator === '>=') {
        searchParams['scrappedQty:ge'] = filter.value
      }
      break
    case 'reservedQty':
      if (filter.operator === '=') {
        searchParams['reservedQty'] = filter.value
      } else if (filter.operator === '<') {
        searchParams['reservedQty:lt'] = filter.value
      } else if (filter.operator === '<=') {
        searchParams['reservedQty:le'] = filter.value
      } else if (filter.operator === '>') {
        searchParams['reservedQty:gt'] = filter.value
      } else if (filter.operator === '>=') {
        searchParams['reservedQty:ge'] = filter.value
      }
      break
    case 'pickedQty':
      if (filter.operator === '=') {
        searchParams['pickedQty'] = filter.value
      } else if (filter.operator === '<') {
        searchParams['pickedQty:lt'] = filter.value
      } else if (filter.operator === '<=') {
        searchParams['pickedQty:le'] = filter.value
      } else if (filter.operator === '>') {
        searchParams['pickedQty:gt'] = filter.value
      } else if (filter.operator === '>=') {
        searchParams['pickedQty:ge'] = filter.value
      }
      break
    case 'lot':
      if (filter.operator === '=') {
        searchParams.lot = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['lot:ct'] = filter.value
      }
      break
    case 'expirationDate':
      if (filter.operator === 'between') {
        Object.assign(
          searchParams,
          applyDateRangeFilter(
            'expirationDate',
            Array.isArray(filter.value) ? (filter.value as Date[]) : [],
            searchParams,
          ),
        )
        break
      }
      Object.assign(
        searchParams,
        applyComparisonOperator(
          'expirationDate',
          filter.operator,
          value,
          searchParams,
        ),
      )
      break

    case 'serial':
      if (filter.operator === '=') {
        searchParams.serial = filter.value
      } else if (filter.operator === 'contains') {
        searchParams['serial:ct'] = filter.value
      }
      break
    case 'product.SKU':
      if (filter.operator === '=') {
        searchParams['product.SKU'] = filter.value
      }
      break
    case 'product.name':
      if (filter.operator === '=') {
        searchParams['product.name'] = filter.value
      }
      break
    case 'place.0.label':
      if (filter.operator === '=') {
        //searchParams['area'] = filter.value
        searchParams['place.0.label'] = filter.value
      }
      break
    case 'place.1.label':
      if (filter.operator === '=') {
        //searchParams['aisle'] = filter.value
        searchParams['place.1.label'] = filter.value
      }
      break
    case 'place.2.label':
      if (filter.operator === '=') {
        //searchParams['shelf'] = filter.value
        searchParams['place.2.label'] = filter.value
      }
      break
    case 'place.3.label':
      if (filter.operator === '=') {
        //searchParams['position'] = filter.value
        searchParams['place.3.label'] = filter.value
      }
      break
    case 'place.4.label':
      if (filter.operator === '=') {
        //searchParams['compartment'] = filter.value
        searchParams['place.4.label'] = filter.value
      }
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}

export function stockSortParams(
  params: StockSearchParams,
  sort: QueryStringSort<StockSortField>,
): StockSearchParams {
  const searchParams: StockSearchParams = {}

  switch (sort.field) {
    case 'onHandQty':
      searchParams.sort = 'onHandQty'
      searchParams.order = sort.order
      break
    case 'scrappedQty':
      searchParams.sort = 'scrappedQty'
      searchParams.order = sort.order
      break
    case 'reservedQty':
      searchParams.sort = 'reservedQty'
      searchParams.order = sort.order
      break
    case 'pickedQty':
      searchParams.sort = 'pickedQty'
      searchParams.order = sort.order
      break
  }

  return {
    ...params,
    ...searchParams,
  }
}
